/* global Ad */
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.regex';
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.repeat';
import {
    preCheck,
    guestTypeChange,
    addUnit,
    bindChange,
    sidebarScroll,
    refreshPersonNumber,
    checkPrice,
    datepickerSetDayAvailabilityCallback,
    getAvailableDates,
} from '@PROJECT_ROOT/assets/desktop/js/lighthouse/reservationSingle';
import '@PROJECT_ROOT/assets/desktop/js/reservation/singleUser';
import '@PROJECT_ROOT/assets/desktop/js/reservation/updateUserProfile';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';

const state = fetchStateFromHtml();

// Mora biti globalna varijabla jer se mijenja ovisno o odabiru jedinice, a koristi ju datepicker
let availableDates = [];

$(() => {
    $('#ReservationLighthouseSingleForm_user_type_new').click().change();
    $('#refreshCalculation').click(preCheck);

    $('#ReservationLighthouseSingleForm_g_type').change(guestTypeChange);
    $('#addUnit').click(addUnit);

    $('select[id$=_selected]').change(refreshPersonNumber);
    $('select[id$=_selected]').change(function addUnitOnChange() {
        if ($(this).val().length === 0 && $('.unitRow').length - $('.unitRow.unitHidden').length > 1) {
            $(this).parents('.unitRow').addClass('unitHidden').hide();
            $('#addUnit').show();
        }
    });

    initDatepicker();
    $('select[id$=_selected]').change(() => {
        getAvailableDates(state.availableDatesUrl).then((response) => {
            availableDates = response.availableDates;
        });
    });

    sidebarScroll();
    bindChange();
    $('#ReservationLighthouseSingleForm_termin_od').change();
    guestTypeChange();
    refreshPersonNumber();
    checkPrice();
});

function initDatepicker() {
    getAvailableDates(state.availableDatesUrl).then((response) => {
        availableDates = response.availableDates;

        Ad.Datepicker.initRange(
            '#ReservationLighthouseSingleForm_termin_od',
            '#ReservationLighthouseSingleForm_termin_do',
            {
                beforeShowDayFrom: datepickerBeforeShowDay,
                beforeShowDayTo: datepickerBeforeShowDay,
                currentText: state.datepickerOptions.currentText,
            },
        );
    });

    function datepickerBeforeShowDay(dt) {
        return datepickerSetDayAvailabilityCallback(dt, availableDates);
    }
}

window.preCheck = preCheck;
